'use client';

import { c as _c } from "react/compiler-runtime";
import React, { type PropsWithChildren, useState } from 'react';
import { VideoPlayerModal } from './VideoPlayerModal';
interface VideoPopupCTAProps {
  videoId: string;
  playerId?: string;
  autoplay?: boolean;
}
export const VideoPopupCTA = t0 => {
  const $ = _c(13);
  const {
    children,
    videoId,
    playerId,
    autoplay
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalOpen(true);
    };
    t2 = () => {
      setIsModalOpen(true);
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <div role="button" tabIndex={0} onClick={t1} onKeyUp={t2}>{children}</div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsModalOpen(false);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== autoplay || $[6] !== isModalOpen || $[7] !== playerId || $[8] !== videoId) {
    t5 = <VideoPlayerModal videoId={videoId} playerId={playerId} autoplay={autoplay} isOpen={isModalOpen} onClose={t4} />;
    $[5] = autoplay;
    $[6] = isModalOpen;
    $[7] = playerId;
    $[8] = videoId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="relative block aspect-video w-full max-w-full">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};